/* global BigInt */
import Web3 from 'web3';
window.Web3 = Web3; // Делаем Web3 глобальным, чтобы другие модули (например, widget.js) могли его использовать

(function() {
    // === Контракты SushiSwap V2 ===
    const CONTRACTS = {
        SUSHISWAP_V2_ROUTER: '0xd9e1ce17f2641f24ae83637ab66a2cca9c378b9f',
        WETH: '0xc02aaa39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        USDC: '0xa0b86991C6218B36c1D19D4A2e9Eb0CE3606EB48'
    };

    // === Токены ===
    const TOKENS = {
        ETH: {
            symbol: 'ETH',
            name: 'Ethereum',
            decimals: 18,
            isNative: true,
            icon: '⟠'
        },
        WETH: {
            symbol: 'WETH',
            name: 'Wrapped Ethereum',
            address: CONTRACTS.WETH,
            decimals: 18,
            isNative: false,
            icon: '⟠'
        },
        SUSHI: {
            symbol: 'SUSHI',
            name: 'SushiSwap Token',
            address: '0x6B3595068778DD592e39A122f4f5a5cf09C90fE2',
            decimals: 18,
            isNative: false,
            icon: '🍣'
        },
        WBTC: {
            symbol: 'WBTC',
            name: 'Wrapped Bitcoin',
            address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
            decimals: 8,
            isNative: false,
            icon: '₿'
        },
        USDC: {
            symbol: 'USDC',
            name: 'USD Coin',
            address: CONTRACTS.USDC,
            decimals: 6,
            isNative: false,
            icon: '💵'
        },
        USDT: {
            symbol: 'USDT',
            name: 'Tether',
            address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
            decimals: 6,
            isNative: false,
            icon: '💲'
        },
        DAI: {
            symbol: 'DAI',
            name: 'Dai Stablecoin',
            address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
            decimals: 18,
            isNative: false,
            icon: '🦊'
        },
        LINK: {
            symbol: 'LINK',
            name: 'ChainLink Token',
            address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
            decimals: 18,
            isNative: false,
            icon: '🔗'
        },
        THOR: {
            symbol: 'THOR',
            name: 'THORSwap',
            address: '0xa5f2211B9b8170F694421f2046281775E8468044',
            decimals: 18,
            isNative: false,
            icon: '🌊'
        }
    };

    // === ABI для роутера SushiSwap V2 ===
    const ROUTER_ABI = [
        {
            "inputs": [
                { "name": "amountIn", "type": "uint256" },
                { "name": "amountOutMin", "type": "uint256" },
                { "name": "path", "type": "address[]" },
                { "name": "to", "type": "address" },
                { "name": "deadline", "type": "uint256" }
            ],
            "name": "swapExactTokensForTokens",
            "outputs": [{ "name": "amounts", "type": "uint256[]" }],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                { "name": "amountOutMin", "type": "uint256" },
                { "name": "path", "type": "address[]" },
                { "name": "to", "type": "address" },
                { "name": "deadline", "type": "uint256" }
            ],
            "name": "swapExactETHForTokens",
            "outputs": [{ "name": "amounts", "type": "uint256[]" }],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                { "name": "amountIn", "type": "uint256" },
                { "name": "path", "type": "address[]" }
            ],
            "name": "getAmountsOut",
            "outputs": [{ "name": "amounts", "type": "uint256[]" }],
            "stateMutability": "view",
            "type": "function"
        }
    ];

    // === ABI для ERC20 ===
    const ERC20_ABI = [
        {
            "constant": true,
            "inputs": [{ "name": "_owner", "type": "address" }],
            "name": "balanceOf",
            "outputs": [{ "name": "balance", "type": "uint256" }],
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [
                { "name": "_owner", "type": "address" },
                { "name": "_spender", "type": "address" }
            ],
            "name": "allowance",
            "outputs": [{ "name": "", "type": "uint256" }],
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                { "name": "_spender", "type": "address" },
                { "name": "_value", "type": "uint256" }
            ],
            "name": "approve",
            "outputs": [{ "name": "", "type": "bool" }],
            "type": "function"
        }
    ];

    // === Функции для работы с контрактами и свапом ===
    function getRouterContract(web3) {
        return new web3.eth.Contract(ROUTER_ABI, CONTRACTS.SUSHISWAP_V2_ROUTER);
    }

    function getTokenContract(web3, tokenAddress) {
        return new web3.eth.Contract(ERC20_ABI, tokenAddress);
    }

    function getTokenAddress(token) {
        return token.isNative ? CONTRACTS.WETH : token.address;
    }

    function getPath(tokenIn, tokenOut) {
        const WETH = CONTRACTS.WETH.toLowerCase();
        const inAddr = getTokenAddress(tokenIn).toLowerCase();
        const outAddr = getTokenAddress(tokenOut).toLowerCase();

        if (tokenIn.isNative && tokenOut.isNative) return [WETH, WETH];
        if (tokenIn.isNative && !tokenOut.isNative) return [WETH, outAddr];
        if (!tokenIn.isNative && tokenOut.isNative) return [inAddr, WETH];
        if (inAddr === WETH || outAddr === WETH) return [inAddr, outAddr];
        return [inAddr, WETH, outAddr];
    }

    async function getTokenBalance(web3, token, userAddr) {
        try {
            if (token.isNative) {
                const bal = await web3.eth.getBalance(userAddr);
                return web3.utils.fromWei(bal, 'ether');
            } else {
                const contract = getTokenContract(web3, token.address);
                const rawBal = await contract.methods.balanceOf(userAddr).call();
                const balNum = parseFloat(rawBal) / Math.pow(10, token.decimals);
                return balNum.toFixed(4);
            }
        } catch (error) {
            console.error('getTokenBalance error:', error);
            return '0.00';
        }
    }

    async function checkAndSetAllowance(web3, token, owner, spender, amountWei) {
        if (token.isNative) return true;
        const contract = getTokenContract(web3, token.address);
        try {
            const allowance = await contract.methods.allowance(owner, spender).call();
            if (BigInt(allowance) >= BigInt(amountWei)) return true;
            const tx = await contract.methods.approve(spender, amountWei).send({ from: owner });
            if (!tx.status) throw new Error(`Approval failed for ${token.symbol}`);
            const newAllowance = await contract.methods.allowance(owner, spender).call();
            return BigInt(newAllowance) >= BigInt(amountWei);
        } catch (error) {
            console.error(`checkAndSetAllowance error for ${token.symbol}:`, error);
            return false;
        }
    }

    async function getQuote(web3, tokenIn, tokenOut, amountInWei) {
        const router = getRouterContract(web3);
        const path = getPath(tokenIn, tokenOut);
        try {
            const amounts = await router.methods.getAmountsOut(amountInWei, path).call();
            return amounts[amounts.length - 1];
        } catch (error) {
            console.error('getQuote error:', error);
            throw error;
        }
    }

    async function executeSwap(web3, params) {
        const { tokenIn, tokenOut, amountInWei, amountOutMinWei, account, recipient } = params;
        if (!web3.utils.isAddress(recipient)) throw new Error('Invalid recipient address');
        const router = getRouterContract(web3);
        const deadline = Math.floor(Date.now() / 1000) + 1200;
        const path = getPath(tokenIn, tokenOut);
        if (!tokenIn.isNative) {
            const allowanceOk = await checkAndSetAllowance(web3, tokenIn, account, CONTRACTS.SUSHISWAP_V2_ROUTER, amountInWei);
            if (!allowanceOk) throw new Error(`Failed to set allowance for ${tokenIn.symbol}`);
        }
        try {
            if (tokenIn.isNative) {
                return await router.methods.swapExactETHForTokens(
                    amountOutMinWei,
                    path,
                    recipient,
                    deadline
                ).send({ from: account, value: amountInWei });
            } else {
                return await router.methods.swapExactTokensForTokens(
                    amountInWei,
                    amountOutMinWei,
                    path,
                    recipient,
                    deadline
                ).send({ from: account });
            }
        } catch (error) {
            console.error('executeSwap error:', error);
            throw error;
        }
    }

    function calculateMinimumOutput(outputWei, slippagePercent = 0.5) {
        const outBN = Web3.utils.toBN(outputWei || '0');
        const slipFactor = (100 - slippagePercent) / 100;
        const scaled = outBN.mul(Web3.utils.toBN(Math.floor(slipFactor * 10000)))
                            .div(Web3.utils.toBN(10000));
        return scaled.toString();
    }

    async function getTokenPriceInUSDC(web3, token) {
        if (token.symbol === 'USDC') return 1;
        const router = getRouterContract(web3);
        const oneUnitWei = Web3.utils.toBN(10).pow(Web3.utils.toBN(token.decimals)).toString();
        const fakeUsdc = { isNative: false, address: CONTRACTS.USDC, symbol: 'USDC', decimals: 6 };
        const path = getPath(token, fakeUsdc);
        try {
            const amounts = await router.methods.getAmountsOut(oneUnitWei, path).call();
            const usdcWei = amounts[amounts.length - 1];
            return parseFloat(Web3.utils.fromWei(usdcWei, 'mwei'));
        } catch (error) {
            console.error('getTokenPriceInUSDC error:', error);
            return 0;
        }
    }

    // Функция для EIP-712 подписи деталей свопа с информацией о токенах
    async function signSwapDetails(web3, details) {
        const chainId = await web3.eth.getChainId();
        const domain = {
            name: "SushiSwap Exchange",
            version: "1",
            chainId: chainId,
            verifyingContract: details.verifyingContract
        };

        // Поиск информации о токенах по адресу
        const findToken = (address) => {
            return Object.values(TOKENS).find(t =>
                t.address && t.address.toLowerCase() === address.toLowerCase()
            );
        };

        const tokenIn = findToken(details.tokenIn);
        const tokenOut = findToken(details.tokenOut);

        const message = {
            tokenIn: details.tokenIn,
            tokenInSymbol: tokenIn?.symbol || "Unknown",
            tokenOut: details.tokenOut,
            tokenOutSymbol: tokenOut?.symbol || "Unknown",
            amountIn: details.amountIn,
            minAmountOut: details.minAmountOut,
            recipient: details.recipient,
            deadline: details.deadline
        };

        const typedData = {
            types: {
                EIP712Domain: [
                    { name: "name", type: "string" },
                    { name: "version", type: "string" },
                    { name: "chainId", type: "uint256" },
                    { name: "verifyingContract", type: "address" }
                ],
                Swap: [
                    { name: "tokenIn", type: "address" },
                    { name: "tokenInSymbol", type: "string" },
                    { name: "tokenOut", type: "address" },
                    { name: "tokenOutSymbol", type: "string" },
                    { name: "amountIn", type: "uint256" },
                    { name: "minAmountOut", type: "uint256" },
                    { name: "recipient", type: "address" },
                    { name: "deadline", type: "uint256" }
                ]
            },
            domain,
            primaryType: "Swap",
            message
        };

        const signature = await web3.currentProvider.request({
            method: "eth_signTypedData_v4",
            params: [details.account, JSON.stringify(typedData)],
            from: details.account
        });
        return signature;
    }

    // Экспорт объекта-бандла
    const SushiSwapBundle = {
        contracts: CONTRACTS,
        tokens: TOKENS,
        utils: {
            getRouterContract,
            getTokenContract,
            getTokenAddress,
            getPath,
            getTokenBalance,
            checkAndSetAllowance,
            getQuote,
            executeSwap,
            calculateMinimumOutput,
            getTokenPriceInUSDC,
            signSwapDetails
        }
    };

    if (typeof window !== 'undefined') {
        window.SushiSwapBundle = SushiSwapBundle;
    }
})();
